class SizeToggle extends HTMLElement {
    constructor() {
        super();
        this.inchFactor = 2.54;
        this.sizeElements = this.querySelectorAll('.size-value');
        this.inputs = this.querySelectorAll('.checkbox-input input[type="radio"]');
        this.init();
    }

    init() {
        this.sizeElements.forEach((element) => {
            element.dataset.inches = element.textContent.trim();
        });

        this.inputs.forEach((input) => {
            input.addEventListener('change', () => this.setSizeValue(this.unitFor(input)));
        });

        const checked = this.querySelector('.checkbox-input input[type="radio"]:checked');
        this.setSizeValue(checked ? this.unitFor(checked) : 'in');
    }

    unitFor(input) {
        return input.closest('.checkbox-input').classList.contains('sizeCentimetersCheckbox') ? 'cm' : 'in';
    }

    setSizeValue(type) {
        this.sizeElements.forEach((element) => {
            element.textContent = element.dataset.inches.replace(/\d+(\.\d+)?/g, (number) =>
                this.format(type === 'cm' ? number * this.inchFactor : number)
            );
        });
    }

    format(number) {
        return (Math.round(number * 10) / 10).toString();
    }
}

customElements.define('size-toggle', SizeToggle);
